import React from "react";

const SalesDashboard = () => {
  return (
    <div
      style={{
        padding: "20px",
      }}
    >
      <h1>Sales Dashboard</h1>
      <p>Sales dashboard will be displayed here.</p>
    </div>
  );
};

export default SalesDashboard;
